// MIRRORED FILE — twin of src/utils/clientInvoiceCurrency.js (invoiceHasMoney, line-for-line).
// CRA's ModuleScopePlugin forbids importing from the repo's src/, so the copy is the only way the
// page can ask the question the server asks. Registered in `PAIRS` of `mirroredUtilParity.test.js`.
//
// D96.4: does the invoice state money? Any line price or cost, any non-zero charge, or - on a
// header-only invoice - its typed total. Changing the currency then moves real money, so it
// converts at the pinned rate instead of relabelling. The page asks this of the SAVED invoice.
import { num } from './invoiceLineMath';

// Every per-line money field a currency change has to restate.
export const LINE_MONEY_FIELDS = ['quoteUnitPrice', 'quoteLineTotal', 'invoiceLineTotal', 'actualUnitCost', 'actualLineCost'];

export function invoiceHasMoney(invoice: any): boolean {
  const items: any[] = Array.isArray(invoice?.items) ? invoice.items : [];
  const charged = (Array.isArray(invoice?.charges) ? invoice.charges : []).some((c: any) => (num(c?.amount) ?? 0) !== 0);
  const typedTotal = items.length === 0 && (num(invoice?.summary?.quotedTotal) ?? 0) !== 0;
  return charged || typedTotal || items.some((line) => LINE_MONEY_FIELDS.some((field) => num(line?.[field]) !== null));
}
